export default __webpack_public_path__ + "static/media/sh.20ec88ca.svg";